import { isOfType } from '@library/guards'

export const BROWSER_TABS = [
  'Stratigraphy',
  'BulkImport',
  'Cartography',
  'Modeling',
  'InterpretationBrowser',
  'DataManager',
  'CrossPlotBrowser',
] as const
export type BrowserTabs = (typeof BROWSER_TABS)[number]
export const isBrowserTab = isOfType(BROWSER_TABS)

export const CORE_TABS = [
  'Window3D',
  'Window2D',
  'Interpretation',
  'Table',
  'Chart',
  'Map',
  'CorrelationScheme',
  'CrossPlot',
  'GeoModule',
] as const
export type TabType = (typeof CORE_TABS)[number]
export const isCoreTab = isOfType(CORE_TABS)

export type GeomateTabType = TabType | BrowserTabs
